import React from "react"

export default function Blog038() {
  return (
    <section>
    <article>
    <h2>38. 01-25-2023</h2>
          <h3>PYTHON</h3>
          <p>
          <strong>I am learning python!</strong>
          <br /><br />
          As a self-taught software developer, I have always been on the lookout for new and exciting ways to challenge myself and improve my skills. Recently, I discovered Ursina, a game engine built on top of Panda3D and written in Python. I have been using it to create a game demo, which I plan to release for free on my website.
          <br /><br />
The process of creating a game using Ursina has been a great exercise in learning Python, a programming language that I had always been interested in but never had the opportunity to work with. Python is a versatile language that is well-suited for a wide range of tasks, from web development to data analysis. However, I found that using it to create a game was a particularly enjoyable and engaging way to learn.
<br /><br />
One of the things that I appreciate about Ursina is how easy it is to get started. The engine comes with a number of built-in tools and features that make it easy to create and prototype game ideas. For example, the built-in physics engine allows for realistic movement and collision detection, and the built-in entities and components system makes it easy to create and manage different types of game objects. Additionally, Ursina is built on top of Panda3D, which is a well-established and widely used game engine, so there is a wealth of resources and tutorials available online.
<br /><br />
As I progressed with my game development, I found that Ursina was also a great way to improve my skills in other areas. For example, working with Ursina helped me to develop a better understanding of 3D math, which is a fundamental concept in game development. Additionally, the process of creating a game also helped me to improve my problem-solving skills, as I had to find creative solutions to a variety of technical challenges.
<br /><br />
Overall, I am very excited about the game demo that I am creating using Ursina. I believe that it will be a great addition to my portfolio, and I look forward to sharing it with others. As a self-taught software developer, I am always on the lookout for new and exciting ways to challenge myself and improve my skills, and I believe that Ursina has provided me with a great opportunity to do just that.
<br /><br />
It's also great that my game development experience will compliment my abilities with React.js, javascript, and web development in the future. I am looking forward to using the skills I learned in game development and apply them to web development. As a developer, being able to work with different technologies and programming languages is always a plus.
<br /><br />
In conclusion, my experience with Ursina and game development has been a great opportunity for me to learn and improve my skills as a self-taught software developer. I am excited to share my game demo with others, and I look forward to using the skills I have learned to continue to grow and develop as a developer.
<br /><br />


<br /><br />
Thank you for your time,
<br /><br />
Eric Polley<br />
Software Developer Intern at In The Zone





         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="https://github.com/ericpolley/game-demo1-bq/archive/refs/heads/main.zip"
              title="Play my game Demo"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Play my Game Demo</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
